module.exports = __webpack_public_path__ + "static/img/aboutBgImg-p.3b5699f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/aboutBgImg-p.png
// module id = A3iX
// module chunks = 1